import { useState } from 'react';
import { Button } from 'react-bootstrap';

import {
    ClientTable,
    Pagination,
    AddClientModal,
    FilterClientOffcanvas,
    DeleteClientModal,
    ContactDetailsModal,
    ViewHistoryOffcanvas
} from './components';

const MyClients = () => {
    // Modal States
    const [show, setShow] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showHistory, setShowHistory] = useState(false);
    const [showContact, setShowContact] = useState(false);

    // Data States
    const [historyList] = useState([
        {
            id: 1,
            date: '14 Aug 2025',
            time: '10:30 AM',
            user: 'John Doe',
            action: 'Created a new client',
            description: 'Added client details and contact information'
        },
        {
            id: 2,
            date: '14 Aug 2025',
            time: '11:15 AM',
            user: 'Jane Smith',
            action: 'Updated email address',
            description: 'Changed primary email to new@example.com'
        },
        {
            id: 3,
            date: '14 Aug 2025',
            time: '2:45 PM',
            user: 'Mike Johnson',
            action: 'Added phone number',
            description: 'Added secondary contact number'
        },
        {
            id: 4,
            date: '13 Aug 2025',
            time: '9:00 AM',
            user: 'Sarah Wilson',
            action: 'Updated address',
            description: 'Updated office location and postal code'
        },
        {
            id: 5,
            date: '13 Aug 2025',
            time: '3:30 PM',
            user: 'John Doe',
            action: 'Added project',
            description: 'Assigned new project "Website Redesign"'
        },
        {
            id: 6,
            date: '12 Aug 2025',
            time: '11:00 AM',
            user: 'Jane Smith',
            action: 'Updated logo',
            description: 'Uploaded new company logo'
        },
        {
            id: 7,
            date: '12 Aug 2025',
            time: '2:15 PM',
            user: 'Mike Johnson',
            action: 'Added note',
            description: 'Added private note about client preferences'
        },
        {
            id: 8,
            date: '11 Aug 2025',
            time: '4:45 PM',
            user: 'Sarah Wilson',
            action: 'Updated status',
            description: 'Changed client status to active'
        },
        {
            id: 9,
            date: '11 Aug 2025',
            time: '10:30 AM',
            user: 'John Doe',
            action: 'Added contact',
            description: 'Added new point of contact'
        },
        {
            id: 10,
            date: '10 Aug 2025',
            time: '1:00 PM',
            user: 'Jane Smith',
            action: 'Initial setup',
            description: 'Completed initial client setup'
        }
    ]);
    const [selectedContact, setSelectedContact] = useState(null);
    const [pageSize, setPageSize] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
    const totalItems = 100; // This would come from your API

    // Client Form States
    const [clientName, setClientName] = useState('');
    const [emails, setEmails] = useState('');
    const [phones, setPhones] = useState('');
    const [logo, setLogo] = useState(null);
    const [address, setAddress] = useState('');
    const [privateNote, setPrivateNote] = useState('');
    const [publicNote, setPublicNote] = useState('');

    // Filter States
    const [showFilter, setShowFilter] = useState(false);
    const [clientFilter, setClientFilter] = useState(null);
    const [projectFilter, setProjectFilter] = useState(null);
    const [assigneeFilter, setAssigneeFilter] = useState(null);
    const [dueDateRange, setDueDateRange] = useState({ from: null, to: null });
    const [budgetRange, setBudgetRange] = useState({ min: '', max: '' });
    const [paymentFilter, setPaymentFilter] = useState(null);
    const [stageFilter, setStageFilter] = useState(null);

    // Filter Options
    const clientOptions = [
        { value: 'client1', label: 'Client 1' },
        { value: 'client2', label: 'Client 2' },
        { value: 'client3', label: 'Client 3' }
    ];

    const projectOptions = [
        { value: 'project1', label: 'Project 1' },
        { value: 'project2', label: 'Project 2' },
        { value: 'project3', label: 'Project 3' }
    ];

    const assigneeOptions = [
        { value: 'user1', label: 'User 1' },
        { value: 'user2', label: 'User 2' },
        { value: 'user3', label: 'User 3' }
    ];

    const paymentOptions = [
        { value: 'paid', label: 'Paid' },
        { value: 'unpaid', label: 'Unpaid' },
        { value: 'partial', label: 'Partial' }
    ];

    const stageOptions = [
        { value: 'planning', label: 'Planning' },
        { value: 'inProgress', label: 'In Progress' },
        { value: 'completed', label: 'Completed' }
    ];
    const totalPages = Math.ceil(totalItems / pageSize);

    // Handler Functions
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const handleDeleteShow = () => setShowDelete(true);
    const handleDeleteClose = () => setShowDelete(false);
    const handleDelete = () => {
        // TODO: Implement delete functionality
        console.log('Deleting client');
        handleDeleteClose();
    };

    const handleHistoryShow = () => {
        setShowHistory(true);
        // History data is already loaded in the state
    };
    const handleHistoryClose = () => {
        setShowHistory(false);
    };

    const handleContactShow = (contact) => {
        setSelectedContact(contact);
        setShowContact(true);
    };
    const handleContactClose = () => {
        setShowContact(false);
        setSelectedContact(null);
    };

    const handleMoveOrCopyShow = () => {
        // TODO: Implement move/copy functionality
        console.log('Move/Copy show');
    };

    const handleLogTimeShow = (data) => {
        // TODO: Implement log time functionality
        console.log('Log time:', data);
    };

    const handleQuickSubtasksShow = () => {
        // TODO: Implement quick subtasks
        console.log('Show quick subtasks');
    };

    const handleEstimateTimeShow = () => {
        // TODO: Implement time estimation
        console.log('Show time estimation');
    };
    return (
        <>
            <div className='c-card-1'>
                <div className='c-card-header-1'>
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <div>
                            Client Management
                        </div>
                        <div className='d-flex align-items-center gap-1'>
                            <Button 
                                variant='outline-primary' 
                                className='btn-sm me-2 text-nowrap'
                                onClick={() => setShowFilter(true)}
                            >
                                <i className="fas fa-filter me-1"></i>
                                Filter
                            </Button>
                            <Button 
                                variant='primary'
                                className='btn-sm text-nowrap'
                                onClick={handleShow}
                            >
                                <i className="fas fa-plus me-1"></i>
                                Add Client
                            </Button>
                        </div>
                    </div>
                </div>
                <div className='c-card-body-1 p-0'>
                    <ClientTable
                        onEdit={handleShow}
                        onMoveOrCopy={handleMoveOrCopyShow}
                        onLogTime={handleLogTimeShow}
                        onViewHistory={handleHistoryShow}
                        onAddSubtasks={handleQuickSubtasksShow}
                        onView={() => {}} // TODO: Implement view handler
                        onDuplicate={() => {}} // TODO: Implement duplicate handler
                        onDelete={handleDeleteShow}
                        onEstimateTime={handleEstimateTimeShow}
                        onContactClick={handleContactShow}
                    />
                </div>
                <div className='c-card-footer-1'>
                    <Pagination
                        pageSize={pageSize}
                        onPageSizeChange={setPageSize}
                        currentPage={currentPage}
                        onPageChange={setCurrentPage}
                        totalPages={totalPages}
                        totalItems={totalItems}
                    />
                </div>
            </div>

            <AddClientModal
                show={show}
                onHide={handleClose}
                clientName={clientName}
                setClientName={setClientName}
                emails={emails}
                setEmails={setEmails}
                phones={phones}
                setPhones={setPhones}
                logo={logo}
                setLogo={setLogo}
                address={address}
                setAddress={setAddress}
                privateNote={privateNote}
                setPrivateNote={setPrivateNote}
                publicNote={publicNote}
                setPublicNote={setPublicNote}
            />

            <FilterClientOffcanvas
                show={showFilter}
                onHide={() => setShowFilter(false)}
                clientFilter={clientFilter}
                setClientFilter={setClientFilter}
                projectFilter={projectFilter}
                setProjectFilter={setProjectFilter}
                assigneeFilter={assigneeFilter}
                setAssigneeFilter={setAssigneeFilter}
                dueDateRange={dueDateRange}
                setDueDateRange={setDueDateRange}
                budgetRange={budgetRange}
                setBudgetRange={setBudgetRange}
                paymentFilter={paymentFilter}
                setPaymentFilter={setPaymentFilter}
                stageFilter={stageFilter}
                setStageFilter={setStageFilter}
                clientOptions={clientOptions}
                projectOptions={projectOptions}
                assigneeOptions={assigneeOptions}
                paymentOptions={paymentOptions}
                stageOptions={stageOptions}
            />

            <ViewHistoryOffcanvas
                show={showHistory}
                onHide={handleHistoryClose}
                historyList={historyList}
            />

            <FilterClientOffcanvas
                show={showFilter}
                onHide={() => setShowFilter(false)}
                clientFilter={clientFilter}
                setClientFilter={setClientFilter}
                projectFilter={projectFilter}
                setProjectFilter={setProjectFilter}
                assigneeFilter={assigneeFilter}
                setAssigneeFilter={setAssigneeFilter}
                dueDateRange={dueDateRange}
                setDueDateRange={setDueDateRange}
                budgetRange={budgetRange}
                setBudgetRange={setBudgetRange}
                paymentFilter={paymentFilter}
                setPaymentFilter={setPaymentFilter}
                stageFilter={stageFilter}
                setStageFilter={setStageFilter}
                projectOptions={projectOptions}
                assigneeOptions={assigneeOptions}
                clientOptions={clientOptions}
                paymentOptions={paymentOptions}
                stageOptions={stageOptions}
            />

            <DeleteClientModal
                show={showDelete}
                onHide={handleDeleteClose}
                onConfirm={handleDelete}
            />

            <ContactDetailsModal
                show={showContact}
                onHide={handleContactClose}
                contact={selectedContact}
            />

            <ViewHistoryOffcanvas
                show={showHistory}
                onHide={handleHistoryClose}
                historyList={historyList}
            />
        </>
    );
};export default MyClients;